import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Image, ImageProps } from 'react-native';

import { AssetColor } from '../../assets/assetColors';
import { usePFPGeneratorContext } from '../contexts/PFPGeneratorContext';

const BASE_64_DATA_URI_PREFIX = 'data:image/svg+xml;base64,';
const KEY_SVG_COLORS = ['#3CFF00', '#7CB16C'];

const modifiedSvgDataUriFromOriginalString = (
  svgString: string,
  assetColor: AssetColor
): string => {
  let modifiedSvgString = svgString;

  // TODO set up default values so we don't need to null check here
  assetColor?.forEach((color, i) => {
    modifiedSvgString = modifiedSvgString.replaceAll(KEY_SVG_COLORS[i], color);
  });

  const svgBase64 = btoa(modifiedSvgString);
  const dataUri = BASE_64_DATA_URI_PREFIX + svgBase64;
  return dataUri;
};

const PFPPreviewPart = ({
  style,
  source,
  color,
  ...props
}: ImageProps & { color: AssetColor }) => {
  const [svgStringSource, setSvgStringSource] = useState<string>();

  useEffect(() => {
    if (typeof source === 'string') {
      const sourceString: string = source;

      if (sourceString.includes('.svg')) {
        fetch(sourceString)
          .then((response) => response.text())
          .then((text) =>
            setSvgStringSource(
              modifiedSvgDataUriFromOriginalString(text, color)
            )
          );
      } else if (sourceString.includes(BASE_64_DATA_URI_PREFIX)) {
        const svgString = atob(
          sourceString.replace(BASE_64_DATA_URI_PREFIX, '')
        );
        setSvgStringSource(
          modifiedSvgDataUriFromOriginalString(svgString, color)
        );
      }
    }
  }, [source, color]);

  return (
    <Image
      style={[styles.pfpPreviewPart, style]}
      source={{ uri: svgStringSource }}
      {...props}
    />
  );
};

type Props = {};

export default React.forwardRef(({}: Props, ref) => {
  const { selectedParts, selectedColors } = usePFPGeneratorContext();

  return (
    <View ref={ref} style={styles.container}>
      {Object.entries(selectedParts).map(([category, part]) => (
        <PFPPreviewPart
          source={part.requirePath}
          color={selectedColors[category]}
          key={category + part}
        />
      ))}
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    aspectRatio: 1,
    width: '100%',
    backgroundColor: '#EEE',
  },
  pfpPreviewPart: {
    ...StyleSheet.absoluteFillObject,
    width: '100%',
    aspectRatio: 1,
  },
});
